'use strict';

let DB = DB || {};
let UTILS = UTILS || {};
let googleMapLoaded = false;

const staticFolder = '/images/'

DB.skrollrInstance = null;
DB.utils = UTILS || {};
DB.metaTags = {};
DB.scrollableAreaPosition = null;

DB.utils.position = $(window).scrollTop();
DB.offsetY = window.pageYOffset;

DB.navigationVisibility = function navbarPosition() {
    let scroll;
    let topNavBar = document.querySelector('.l-navbar');
    let leftMenu = document.querySelector('.l-menu');

    if (!document.querySelector('body').classList.contains('stop-scrolling')) {
        scroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

        if (topNavBar && leftMenu) {
            if (scroll > DB.utils.position && DB.utils.position > -1) {
                topNavBar.classList.add('l-navbar--hidden');

                if (!($('.website-holder--open').length)) {
                    leftMenu.classList.add('l-menu--hidden');
                }
            } else {
                topNavBar.classList.remove('l-navbar--hidden');
                leftMenu.classList.remove('l-menu--hidden');
            }
        }

        DB.utils.position = scroll;
    }
};

DB.mobileMenu = {
    navbarHeight: function () {
        return $('.l-navbar').outerHeight();
    },
    primaryMenu: $('.l-navbar__primary-nav'),
    secondaryMenu: $('.l-menu'),
    secondaryMenuLinks: $('.l-menu__links'),
    showMenuLinks: function (options) {
        if (!options.links) {
            return;
        }

        options.links.each(function (index) {
            var self = this;
            let time = 0;

            setTimeout(function () {
                $(self).addClass('animated fadeInDown');
            }, time);

            time = time + 100;
        });
    },
    init: function () {
        $('.js-open-burger-menu').on('click', function () {
            const burgerElement = $('.burger');

            burgerElement.toggleClass('burger--open');

            // opening burger menu
            if (burgerElement.hasClass('burger--open')) {
                DB.utils.disableBodyScrolling();

                setTimeout(function () {
                    DB.mobileMenu.showMenuLinks({ links: $('.l-navbar__primary-nav-link') });
                }, 300);

                DB.mobileMenu.primaryMenu.slideToggle(function () {
                    const ua = window.navigator.userAgent;
                    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
                    const webkit = !!ua.match(/WebKit/i);
                    const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
                    const firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                    const mozilla = navigator.userAgent.toLowerCase().indexOf('mozilla') > -1;

                    let primaryMenuHeight = burgerElement.outerHeight() + DB.mobileMenu.navbarHeight();

                    if (firefox || mozilla) {
                        primaryMenuHeight = primaryMenuHeight + 70;
                    }

                    if (DB.utils.screenSize().x < DB.utils.screenSize().y) {
                        if (iOSSafari || firefox) {
                            primaryMenuHeight = primaryMenuHeight + 160;
                        } else {
                            primaryMenuHeight = primaryMenuHeight + 90;
                        }
                    }

                    DB.mobileMenu.secondaryMenuLinks.css({ 'padding-top': primaryMenuHeight });
                    DB.mobileMenu.showMenuLinks({ links: $('.l-menu__link') });
                });
                DB.mobileMenu.secondaryMenu.slideToggle();

                // closing burger menu
            } else {
                $('.l-menu__link, .l-navbar__primary-nav-link')
                    .removeClass('animated')
                    .removeClass('fadeInDown');

                DB.mobileMenu.primaryMenu.fadeOut(200);
                DB.mobileMenu.secondaryMenu.fadeOut(200);
                DB.utils.enableBodyScrolling();
                DB.megamenu.close('all');
                return;
                // here it's the end for the closing action
            }
        });
    }
};


DB.sidebar = function () {
    $('.js-toggle-sidebar-mobile').on('click', function () {
        let sidebar = $('.l-sidebar');

        if (sidebar.hasClass('l-sidebar--open')) {
            DB.utils.enableBodyScrolling();
            sidebar.removeClass('l-sidebar--open');
        } else {
            DB.utils.disableBodyScrolling();
            sidebar.addClass('l-sidebar--open');
        }

        return false;
    });
};

DB.megamenu = {
    close: function (all) {
        let x = UTILS.screenSize().x;
        let megamenu = $('.megamenu--active');

        if (!megamenu) {
            return;
        }

        let megamenuItems = x < 1024 ? megamenu.children('.megamenu__links').children('.megamenu__item') : megamenu.children('.megamenu__links').find('.megamenu__link--lvl-1');

        if (x >= 1024) {
            megamenu.addClass('closing-mm2');

            setTimeout(function () {
                megamenu.removeClass('closing-mm2');
            }, 2000);
        }

        if ((x < 1024 && !$('.l-navbar__go-back').hasClass('l-navbar__go-back--lvl-2')) || x >= 1024) {

            this.animateCascadeItems({ items: megamenuItems, open: false });

            setTimeout(function () {
                megamenu.slideToggle();
            }, megamenuItems.length * 100);

            megamenu.removeClass('megamenu--active');
        }

        // disable "back" button on mobile
        if ($('.l-navbar__go-back').hasClass('l-navbar__go-back--lvl-2')) {
            $('.l-navbar__go-back').removeClass('l-navbar__go-back--lvl-2');
            DB.megamenu.closeMegamenuLvl2($('.js-mm2:visible').parent());
        } else {
            $('.l-navbar__go-back').removeClass('l-navbar__go-back--active');
        }


        if (all) {
            setTimeout(function () {
                DB.megamenu.close();
            }, 500);
        }
    },
    animateCascadeItems: function (options) {
        if (!options.items) {
            return;
        }

        let time = 200;
        let items = options.items;

        if (options.open === false) {
            time = 0;
            items = $(items.get().reverse());
        }

        items.each(function (index) {
            var self = this;

            setTimeout(function () {
                if (options.open) {
                    $(self).addClass('animated fadeInDown');
                    setTimeout(function () {
                        $(self).addClass('visible').removeClass('animated fadeInDown');
                    }, time)
                } else {
                    $(self).addClass('animated fadeOutUp');
                }

            }, time);

            time = time + 100;
        });

        if (options.open === false) {
            setTimeout(function () {
                items
                    .removeClass('animated')
                    .removeClass('fadeOutUp')
                    .removeClass('visible');
            }, time + 500);
        }
    },
    openMegamenu: function (obj) {
        let x = UTILS.screenSize().x;
        const megamenuId = $(obj).data('open-megamenu-id');
        const megamenu = $('.megamenu[data-megamenu-id="' + megamenuId + '"]');
        let megamenuItems = x < 1024 ? megamenu.children('.megamenu__links').children('.megamenu__item') : megamenu.children('.megamenu__links').find('.megamenu__link--lvl-1');

        if (megamenu.hasClass('megamenu--active')) {

            DB.megamenu.close();

        } else {

            let anyOpenedMegamenuId = $('.megamenu--active').data('megamenu-id');

            if (anyOpenedMegamenuId !== megamenuId) {
                $('.megamenu--active').find('.megamenu__item')
                    .removeClass('animated')
                    .removeClass('fadeInDown')
                    .removeClass('visible')
                    .removeClass('fadeOutUp');
                $('.megamenu--active').removeClass('megamenu--active').fadeOut(200);
            }

            megamenu.slideToggle();
            megamenu.addClass('megamenu--active')
            DB.megamenu.animateCascadeItems({ items: megamenuItems, open: true });

            // enable "back" button on mobile
            $('.l-navbar__go-back').addClass('l-navbar__go-back--active');
        }

        return false;
    },
    openMegamenuLvl2: function (item) {
        item.children('.megamenu__link').addClass('underline-multiline-hover--active');
        item.children('.js-mm2').slideDown();
        item.children('.js-mm2').addClass('mm2-open');
    },
    closeMegamenuLvl2: function (item) {
        item.children('.megamenu__link').removeClass('underline-multiline-hover--active');
        item.children('.js-mm2').slideUp();
        item.children('.js-mm2').removeClass('mm2-open');
    },
    init: function () {
        $('.js-open-megamenu').on('click', function () {
            DB.megamenu.openMegamenu(this);
            $(this).hasClass('underline-active') ? $(this).removeClass('underline-active') : $(this).addClass('underline-active');
        });

        $('.js-open-mobile-mm2 > a').click(function (event) {
            let x = UTILS.screenSize().x;
            let item = $(this).parent();

            if (x < 1024) {
                DB.megamenu.openMegamenuLvl2(item);
                $('.l-navbar__go-back').addClass('l-navbar__go-back--lvl-2');;
                return false;
            }
        });

        $(document).click(function (e) {
            let x = UTILS.screenSize().x;

            if (!e.target.classList.contains('js-open-megamenu') && $(e.target).closest('.js-open-megamenu')) {
                x >= 1024 ? DB.megamenu.close() : void 0;
            }
        });
    }
};

DB.searchForm = function () {
    $('.js-toggle-search-form').on('click', function () {
        const searchForm = $('.l-navbar__search-form');

        searchForm.animate({
            width: 'toggle'
        });

        $('#search-phrase').focus();
    });
};

DB.underlineHoverEffect = function () {
    wrapInsideElement('.underline-hover:not(.js-ready)', '<span></span>', null, 'js-ready');
};

DB.buttonHoverEffect = function () {
    wrapInsideElement('.btn', '<span></span>', 'btn__inner');
};

DB.skrollr = function () {
    if (!document.querySelector('.skrollr')) {
        return;
    }

    DB.skrollrInstance = skrollr.init();

    if (DB.skrollrInstance.isMobile()) {
        DB.skrollrInstance.destroy();
    }
};

DB.sliders = {
    generalSlider: function () {
        let sliders = document.querySelectorAll('.js-general-slider');

        if (!sliders.length) {
            return;
        }


        [].forEach.call(sliders, function (slider) {
            let autoplayTimeout = slider.dataset.autoplayTimeout || false;
            let settings = {
                items: slider.dataset.items || 1,
                navigation: false,
                pagination: slider.dataset.pagination || true,
                autoHeight: true,
                autoplayHoverPause: false,
                nav: slider.dataset.nav || true,
                loop: true,
                lazyLoad: true,
            };

            if (slider.classList.contains('owl-carousel--nav-left-right')) {
                settings.navText = ['<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.54 13.52"><path id="Line" d="M0,6.76H25" style="fill:none;stroke:#090b09;stroke-miterlimit:10;stroke-width:2px"/><path id="Path_5" data-name="Path 5" d="M18,.76l7,6-7,6" style="fill:none;stroke:#090b09;stroke-miterlimit:10;stroke-width:2px"/></svg></span>', '<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.54 13.52"><path id="Line" d="M0,6.76H25" style="fill:none;stroke:#090b09;stroke-miterlimit:10;stroke-width:2px"/><path id="Path_5" data-name="Path 5" d="M18,.76l7,6-7,6" style="fill:none;stroke:#090b09;stroke-miterlimit:10;stroke-width:2px"/></svg></span>'];
            }

            if (autoplayTimeout) {
                settings.autoplay = true;
                settings.autoplayTimeout = autoplayTimeout;
            }

            $(slider).owlCarousel(settings)
        });
    },
    customSlider: function () {
        let sliders = $('.js-custom-slider');

        if (!sliders.length) {
            return;
        }
        sliders.each(function () {
            let slider = $(this);
            let sliderId = slider.data('slider-id');

            let settings = {
                items: 1,
                navigation: false,
                pagination: true,
                autoHeight: true,
                autoplayHoverPause: true,
                nav: true,
                mouseDrag: false,
                loop: slider.find('> *').length > 1
            };

            slider = slider.owlCarousel(settings);

            $('.js-custom-slider-menu[data-slider-menu-id="' + sliderId + '"]').on('click', 'button', function () {
                let slideId = $(this).data('slide-id');
                slider.trigger('to.owl.carousel', [slideId, 500, true]);

                $(this).closest('.js-custom-slider-menu').find('.underline-hover--active').removeClass('underline-hover--active');
                setTimeout(() => {
                    $(this).addClass('underline-hover--active');
                }, 300);
            });
        });
    },
    tabs: function () {
        let sliders = $('.js-tabs');

        if (!sliders.length) {
            return;
        }
        sliders.each(function () {
            let slider = $(this);
            let sliderId = slider.data('slider-id');

            let settings = {
                items: 1,
                navigation: false,
                pagination: false,
                autoHeight: true,
                autoplay: false,
                autoplayHoverPause: false,
                nav: false,
                mouseDrag: false
            };
            let activeTabElement = $(this).parent().find('[data-active-tab-class]').length ? $(this).parent().find('[data-active-tab-class]').data('active-tab-class') : 'tabs__link--active';

            if ($('.' + activeTabElement).length) {
                settings.onDragged = function (event) {
                    slider.parent().find('.' + activeTabElement).removeClass(activeTabElement);
                    slider.parent().find('[data-slide-id="' + event.item.index + '"]').addClass(activeTabElement);
                };
            }

            slider = slider.owlCarousel(settings);

            $('.js-tabs-menu[data-slider-menu-id="' + sliderId + '"]').on('click', 'button', function () {
                let slideId = $(this).data('slide-id');
                slider.trigger('to.owl.carousel', [slideId, 500, true]);

                $(this).closest('.js-tabs-menu').find('.' + activeTabElement).removeClass(activeTabElement);
                $(this).addClass(activeTabElement);
            });
        });
    },
    boxCarousel: function () {
        let sliders = $('.js-box-carousel');

        if (!sliders.length) { return; }

        // becuase there is left offset for the slider if there are more than 4 items, if you slide right, the last element is not 100% visible
        // that's why I decided to add an empty item to help slide the carousel to the very end and this way last item is visible 100%
        function addOrRemoveEmptyItem({ slider }) {
            if (!slider) {
                return;
            }

            if (!slider.hasClass('owl-carousel--left-offset')) {
                return;
            }

            if (DB.utils.screenSize().x > 1200) {
                if (!slider.find('.js-additional-empty-item').length) {
                    slider.append('<div class="js-additional-empty-item"></div>');
                }
            } else {
                if (slider.find('.js-additional-empty-item').length) {
                    slider.find('.js-additional-empty-item').remove();
                }
            }
        }

        sliders.each(function () {
            let slider = $(this);

            let settings = {
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1200: {
                        items: 3
                    },
                    2000: {
                        items: 4
                    }
                },
                margin: 40,
                navigation: false,
                pagination: false,
                autoHeight: true,
                autoplayHoverPause: false,
                nav: slider.data('nav') || true,
                navText: ['<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.54 13.52"><path id="Line" d="M0,6.76H25" style="fill:none;stroke:#090b09;stroke-miterlimit:10;stroke-width:2px"/><path id="Path_5" data-name="Path 5" d="M18,.76l7,6-7,6" style="fill:none;stroke:#090b09;stroke-miterlimit:10;stroke-width:2px"/></svg></span>', '<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.54 13.52"><path id="Line" d="M0,6.76H25" style="fill:none;stroke:#090b09;stroke-miterlimit:10;stroke-width:2px"/><path id="Path_5" data-name="Path 5" d="M18,.76l7,6-7,6" style="fill:none;stroke:#090b09;stroke-miterlimit:10;stroke-width:2px"/></svg></span>'],
                mouseDrag: true,
                loop: false,
                onInitialize: function () {
                    addOrRemoveEmptyItem({ slider });
                },
                onResized: function () {
                    addOrRemoveEmptyItem({ slider });
                }
            };

            slider = slider.owlCarousel(settings);
        });
    },
    init: function () {
        this.generalSlider();
        this.customSlider();
        this.boxCarousel();
        this.tabs();
    }
};

DB.scrollToActiveElement = function () {
    const scrollableArea = $('.js-scroll-to-active-element');
    const activeElement = $('.js-scroll-to-active-element .js-active');
    let scrollTopPosition = null;
    let topOffset;

    if (!activeElement.length || !scrollableArea.length) {
        DB.scrollableAreaPosition = null;
        return;
    }

    // horizontal
    if (DB.utils.screenSize().x <= 767) {
        let leftOffset = activeElement.offset().left - scrollableArea.offset().left + scrollableArea.scrollLeft() - 25;
        scrollableArea.animate({ scrollLeft: leftOffset });
    }

    // vertical
    else {
        topOffset = activeElement.offset().top - scrollableArea.offset().top + scrollableArea.scrollTop() - 25;
        scrollableArea.animate({ scrollTop: topOffset });
    }
};

DB.backdrop = {
    layer: $('.backdrop'),
    open: function () {
        this.layer.addClass('backdrop--opened');
    },
    close: function () {
        this.layer.removeClass('backdrop--opened');
    }
};

// Map for the contact page
DB.map = {
    loadScript: function () {
        if (!googleMapLoaded) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyAanzKjF6LiHz-vILwxR2Tp_X4IFjeuVmo&' +
                'callback=DB.map.load';
            document.body.appendChild(script);
            googleMapLoaded = true;
        } else {
            DB.map.load();
        }
    },

    load: function (selector = '.js-map') {
        function init() {
            var draggable;
            var isMobile = function () {
                try { document.createEvent("TouchEvent"); return true; }
                catch (e) { return false; }
            };
            if (isMobile()) {
                draggable = false;
            } else {
                draggable = true;
            }

            const maps = document.querySelectorAll(selector);
            [].forEach.call(maps, function (mapObj) {

                var myLatLngX = mapObj.getAttribute('data-latitude');
                var myLatLngY = mapObj.getAttribute('data-longitude');

                var mapOptions = {
                    zoom: 15,
                    center: new google.maps.LatLng(myLatLngX, myLatLngY),
                    disableDefaultUI: true,
                    scrollwheel: false,
                    draggable: draggable,

                    zoomControlOptions: {
                        style: google.maps.ZoomControlStyle.LARGE,
                        position: google.maps.ControlPosition.RIGHT_TOP
                    },

                    styles: [
                        {
                            "featureType": "all",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "saturation": 36
                                },
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 40
                                }
                            ]
                        },
                        {
                            "featureType": "all",
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "all",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 17
                                },
                                {
                                    "weight": 1.2
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 29
                                },
                                {
                                    "weight": 0.2
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 18
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 19
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        }
                    ]
                };

                var mapElement = mapObj;
                var map = new google.maps.Map(mapElement, mapOptions);
                var image = staticFolder + 'location-pin.svg';
                var marker = new google.maps.Marker({
                    title: '',
                    position: map.getCenter(),
                    map: map,
                    icon: {
                        url: image,
                        scaledSize: new google.maps.Size(50, 71)
                    }
                });

                google.maps.event.addDomListener(window, 'resize', function () {
                    var center = map.getCenter();
                    google.maps.event.trigger(map, 'resize');
                    map.setCenter(center);
                });
            });
        }
        init();
    },
    initMap: function () {
        if ($('.js-map:not(.js-map-on-demand)').length) {
            const mapWaypoint = new Waypoint({
                element: $('.js-map')[0],
                handler: function (direction) {
                    if (direction === 'down') {
                        DB.map.load();
                    }
                },
                offset: '80%'
            });
        }
    }
};

DB.utils.disableBodyScrolling = function () {
    DB.offsetY = window.pageYOffset;
    $('body').css({ top: -DB.offsetY + 'px' });
    $('body').addClass('stop-scrolling');
};

DB.utils.enableBodyScrolling = function () {
    $('body').removeClass('stop-scrolling');
    $(window).scrollTop(DB.offsetY);
};

DB.contact = {
    contactButton: null,
    layer: $('.l-contact'),
    openTopNavbar: function () {
        $('body > .l-navbar').removeClass('l-navbar--hidden');
    },
    hideTopNavbar: function () {
        $('body > .l-navbar').addClass('l-navbar--hidden');
    },
    openContactLayer: function () {
        DB.contact.layer.fadeIn();
        DB.contact.layer.addClass('l-contact--opened');
        DB.map.loadScript();
        DB.megamenu.close();
    },
    closeContactLayer: function () {
        DB.contact.layer.fadeOut();
        DB.contact.layer.removeClass('l-contact--opened');
    },
    runOpeningContact: function (options = {}) {
        if (options.button) {
            DB.contactButton = options.button;
        }

        DB.contact.hideTopNavbar();

        setTimeout(function () {
            DB.backdrop.open();
        }, 100);

        setTimeout(function () {
            DB.contact.openContactLayer();
        }, 300);

        setTimeout(function () {
            if (DB.contactButton) {
                DB.contactButton.addClass('underline-hover--active');
            }

            DB.utils.disableBodyScrolling();
        }, 1000);
    },
    runClosingContact: function () {
        DB.contact.closeContactLayer();

        setTimeout(function () {
            DB.backdrop.close();
        }, 400);

        setTimeout(function () {
            DB.utils.enableBodyScrolling();
            DB.contact.openTopNavbar();

            if (DB.contactButton) {
                DB.contactButton.removeClass('underline-hover--active');
            }
        }, 300);
    },
    fireContactViaHashId: function () {
        if (window.location.hash && window.location.hash === '#contact') {
            DB.contact.runOpeningContact({ button: $('.js-close-contact-before-leave[href="#contact"]') });
        }
    },
    initLinksToOpenContact: function () {
        $('.website-holder a[href^="#contact"]').on('click', function () {
            if (DB.contact.layer.hasClass('l-contact--opened')) {
                DB.contact.runClosingContact();
            } else {
                DB.contact.runOpeningContact();
            }

            return false;
        });
    },
    init: function () {
        $('.js-close-contact').on('click', function () {
            DB.contact.runClosingContact();
            return false;
        });

        $('.l-menu a[href^="#contact"], .l-navbar a[href^="#contact"], .l-footer a[href^="#contact"]').on('click', function () {
            if (DB.contact.layer.hasClass('l-contact--opened')) {
                DB.contact.runClosingContact();
            } else {
                DB.contact.runOpeningContact({ button: $(this) });
            }

            return false;
        });

        // open contact layer on initial page load
        this.fireContactViaHashId();
    }
};

DB.comparisonBlock = {
    selectedDestination: null,
    selectedTechnology: null,
    loadComparison: function ({ destination, technology }) {
        let id = destination + '-' + technology;
        $('[data-slider-id="' + id + '"]').fadeIn();

        setTimeout(function () {
            $('[data-horizontal-menu-id="' + id + '"]').fadeIn();
        }, 400);

        if (DB.utils.screenSize().x < 768) {
            DB.utils.scrollToID('#js-comparison-content');
        }
    },
    hideWelcomeMessage: function () {
        $('.js-welcome-screen').fadeOut(0);
    },
    openWelcomeMessage: function () {
        setTimeout(function () {
            $('.js-welcome-screen').fadeIn();
        }, 300);
    },
    hideOpenComparisons: function () {
        $('.js-comparison-slider').fadeOut(300);
    },
    init: function () {
        // destination selection
        $('.js-select-destination').on('change', function () {
            DB.comparisonBlock.selectedDestination = $(this).val();
            DB.comparisonBlock.selectedTechnology = null;
            let disabledTechnologies = $(this).data('disabled-technologies');


            DB.comparisonBlock.hideOpenComparisons();
            DB.comparisonBlock.openWelcomeMessage();

            $('.js-select-technology').attr('disabled', false).prop('checked', false);
            disabledTechnologies.forEach(function (technology, index) {
                $('#' + technology).attr('disabled', true);
            });
        });

        // technology selection
        $('.js-select-technology').on('change', function () {
            $('.js-comparison-slider').fadeOut(0);

            DB.comparisonBlock.selectedTechnology = $(this).val();
            DB.comparisonBlock.hideWelcomeMessage();
            DB.comparisonBlock.loadComparison({
                destination: DB.comparisonBlock.selectedDestination,
                technology: DB.comparisonBlock.selectedTechnology
            });
        });
    }
};

DB.selectBox = {
    redirectType: function () {
        $('.js-select-redirect').each(function (index) {
            var self = this;
            $(self).css('display', 'none');

            $(self).selectbox({
                onOpen: function (inst) {
                    var id = inst.uid,
                        selectedText = $('#sbSelector_' + id).text(),
                        options = $('#sbOptions_' + id + ' li');

                    options.each(function (index) {
                        if ($(this).find('a').text() === selectedText) {
                            $(this).addClass('selected');
                        } else {
                            $(this).removeClass('selected');
                        }
                    });
                },
                onClose: function (inst) {

                },
                onChange: function (val, inst) {
                    $(self).val(val).change();

                    if (val !== '-1') {
                        window.location = val;
                    }
                    if (val === 0) {
                        $(self).parent().find('.sbHolder').removeClass('selected');
                    } else {
                        $(self).parent().find('.sbHolder').addClass('selected');
                    }
                },
                effect: "slide"
            });
        });
    },
    ajaxType: function () {
        $('.js-filter-ajax').each(function (index) {
            var self = this;
            $(self).css('display', 'none');
            $('.sbOptions a').attr('href', '');
            $(self).selectbox({
                onOpen: function (inst) {
                    var id = inst.uid,
                        selectedText = $('#sbSelector_' + id).text(),
                        options = $('#sbOptions_' + id + ' li');

                    options.each(function (index) {
                        if ($(this).find('a').text() === selectedText) {
                            $(this).addClass('selected');
                        } else {
                            $(this).removeClass('selected');
                        }
                    });
                },
                onClose: function (inst) {

                },
                onChange: function (val, inst) {
                    $(self).val(val).change();

                    if (val !== '-1') {

                        var selectSourceUID = inst.uid,
                            sourceSelect = document.querySelector('[sb="' + selectSourceUID + '"]'),
                            filterType = $(this).data('filter-type'),
                            selectedOption = $(sourceSelect).find(":selected"),
                            slug = val,
                            withoutTopicRefinement = selectedOption.data('no-topics') || false;

                        DB.refinement.filterBy(filterType, slug, withoutTopicRefinement);

                    }
                    if (val === 0) {
                        $(self).parent().find('.sbHolder').removeClass('selected');
                    } else {
                        $(self).parent().find('.sbHolder').addClass('selected');
                    }
                },
                effect: "slide"
            });
        });

        $('.js-refine-by-topic').on('click', function () {
            let topicSlug = $(this).data('slug');
            DB.refinement.filterBy('label', topicSlug, false);

            return false;
        });
    },
    init: function () {
        this.redirectType();
        this.ajaxType();
    }
};

DB.gifOnHover = function () {
    $('.js-gif-on-hover').hover(
        function () {
            let gifImg = $(this).data('img-on-hover');
            $(this).css('background-image', 'url(' + gifImg + ')');
        }, function () {
            let staticImg = $(this).data('img');
            $(this).css('background-image', 'url(' + staticImg + ')');
        }
    );
};

DB.refinement = {
    groupRevealed: null,
    getCurrentCategorySlug: function () {
        return $('[data-filter-category]').attr('data-filter-category');
    },
    getCategoryName: function (slug) {
        var name = $('[data-param="' + slug + '"]').html();

        if (name) {
            name = name.trim();
        }

        return name;
    },
    getLabelName: function (slug) {
        var name = $('input[value="' + slug + '"]').parent().find('.js-label-name').html();

        if (name) {
            name = name.trim();
        }

        return name;
    },
    getCurrentLabelSlug: function () {
        return $('input[name="labelSlug"]:checked').val();
    },
    filterBy: function (type, value, withoutTopicRefinement) {
        var categorySlug = DB.refinement.getCurrentCategorySlug();
        var labelSlug = DB.refinement.getCurrentLabelSlug();
        var url;

        if (type === 'category') {
            if (withoutTopicRefinement) {
                url = value;
                DB.refinement.trackEvent(value);
            } else {
                url = value + (labelSlug ? '/' + labelSlug : '');
                DB.refinement.trackEvent(value, labelSlug);
            }

        } else if (type === 'label') {
            url = categorySlug + '/' + value;
            DB.refinement.trackEvent(categorySlug, value);

        } else {
            url = categorySlug;
            DB.refinement.trackEvent(categorySlug);
        }

        history.pushState({ url: url }, null, url);
        DB.pushStateCounter++;
        DB.refinement.requestContent(url);
    },
    trackEvent: function (categorySlug, labelSlug) {
        var ga = window.ga || null;
        if (!ga) {
            return true;
        }

        var categoryName = DB.refinement.getCategoryName(categorySlug);
        var labelName = DB.refinement.getLabelName(labelSlug);
        var data = {
            'hitType': 'event',
            'eventCategory': 'Resources: ' + categoryName,
            'eventAction': labelSlug ? 'refined with' : 'selected',
            'eventLabel': labelSlug ? labelSlug : ''
        };

        ga('send', data);
    },
    findParams: function (value) {

        if (value.indexOf('?') >= 0) {
            value += '&';
        } else {
            value += '?';
        }

        return value + Math.random();
    },
    requestContent: function (url) {
        $('.loading').fadeIn();

        if (DB.infiniteElement) {
            DB.infiniteElement.destroy();
        }

        if (url.slice(-1) === '/') {
            url = url.slice(0, -1);
        }

        url += (DB.refinement.groupRevealed ? '?groupRevealed=' + DB.refinement.groupRevealed : '');
        var newUrl = DB.refinement.findParams(url);

        setTimeout(function () {
            $.ajax({
                url: newUrl,
                dataType: 'html',
                success: function (responseText) {

                    $('#js-content').replaceWith(responseText);

                    var codes = $('#js-content').find("script");

                    for (var i = 0; i < codes.length; i++) {
                        eval(codes[i].text);
                    }

                    document.title = DB.metaTags.title;
                    $('meta[name=description]').attr('content', DB.metaTags.description);

                    $('html, body').animate({ scrollTop: 0 }, 'slow');

                    Waypoint.destroyAll();

                    setTimeout(function () {
                        Waypoint.refreshAll();
                        runUniversalScripts();
                    }, 200);

                    setTimeout(function () {
                        $('.loading').fadeOut();
                    }, 200);
                },

                error: function (responseText) {
                    setTimeout(function () {
                        $('.loading').fadeOut();
                    }, 200);
                }
            });
        }, 300);

        return false;
    },
    initPopstate: function () {
        window.addEventListener('popstate', function (e) {
            var character = e.state;

            if (character === null && DB.pushStateCounter) {
                location.reload();
            } else if (character && character.url) {
                DB.refinement.requestContent(character.url);
            }
        });
    },

    // static refinement (refine on the same page, like on Awards page)
    static: function () {
        /* function needed on Awards page for the refinement - it reorders columns in entries once they filtered */

        function adjustColumnsFeaturedWidth() {
            var i = 0;
            $('.js-toRefine:not(.js-invisible)').each(function (entry) {
                var column = $(this).find('div[class*="col-"]');
                column.removeClass("col-md-push-7 col-md-pull-5");

                if (i % 2 != 0) {
                    column.first().addClass("col-md-push-7");
                    column.eq(1).addClass("col-md-pull-5");
                }

                i++;
            });
        }

        $('.refinement--dynamic .sbOptions a').on('click', function () {
            var category = $(this).attr('rel');

            if (category == 'all') {
                $('.js-toRefine').removeClass('js-invisible').fadeIn(200);
            } else {
                category = parseInt(category);
                $('.js-toRefine').addClass('animation-fadeInUp js-invisible').fadeOut(0);

                var array = $('.js-toRefine').map(function () {
                    if ($(this).data('id').indexOf(category) > -1) {
                        $(this).removeClass('js-invisible').fadeIn(0);
                    }
                }).get();

                setTimeout(() => DB.utils.animationedSections(), 200);
            }
            adjustColumnsFeaturedWidth();

            return false;
        });
    },
    init: function () {
    }
};

DB.accordion = {
    init: function () {
        $('.js-toggle-accordion').on('click', function () {
            let accordion = $(this).closest('.accordion');
            accordion.toggleClass('accordion--active');
            accordion.find('.accordion__content').slideToggle();

            return false;
        });
    }
};

DB.audioPlayer = {
    players: function () {
        return document.querySelectorAll('.js-audio-player')
    },
    init: function () {
        let players = this.players();

        if (!players.length) {
            return;
        }

        [].forEach.call(players, (player) => {
            let durationSpecified = player.getAttribute('data-duration');
            $(player).mediaelementplayer({
                duration: durationSpecified ? parseInt(durationSpecified) : 120,
                alwaysShowControls: true,
                features: ['playpause', 'volume', 'current', 'duration', 'progress'],
                audioVolume: 'horizontal',
                audioWidth: 400
            });
        });
    }
};

DB.calculator = function () {
    var sizenum = 14;

    let bps = new Array(sizenum);
    bps[1] = "14400.0";
    bps[2] = "28800.0";
    bps[3] = "56000.0";
    bps[4] = "64000.0";
    bps[5] = "128000.0";
    bps[6] = "256000.0";
    bps[7] = "384000.0";
    bps[8] = "512000.0";
    bps[9] = "1000000.0";
    bps[10] = "2000000.0";
    bps[11] = "10000000.0";
    bps[12] = "100000000.0";
    bps[13] = "1000000000.0";
    bps[14] = "10000000000.0";

    function getFactor() {
        return $('input[name=fileSizeType]:checked').val();
    }

    function calc() {
        var factor = getFactor();
        var filesize = parseFloat($('#fileSize').val());

        if (factor != 0 && filesize != "NaN") {
            for (let x = 9; x <= sizenum; x++) {
                var filetime = (factor * filesize) / ((bps[x] / 8) / 1024);

                let millenium = Math.floor(filetime / 31536000000);
                filetime = filetime - (millenium * 31536000000)

                let century = Math.floor(filetime / 3153600000);
                filetime = filetime - (century * 3153600000)

                let year = Math.floor(filetime / 31536000);
                filetime = filetime - (year * 31536000);

                let day = Math.floor(filetime / 86400);
                filetime = filetime - (day * 86400)

                let hour = Math.floor(filetime / 3600);
                filetime = filetime - (hour * 3600);

                let minute = Math.floor(filetime / 60);
                filetime = filetime - (minute * 60);

                let second = Math.floor(filetime);

                var resultString = "";
                if (hour <= 0 && minute <= 0 && second <= 0 && day <= 0 && year <= 0 && century <= 0 && millenium <= 0) {
                    resultString = "Less than a second";
                } else {
                    if (century >= 1 || millenium >= 1) {
                        resultString = "Impractical length of time!";
                    } else {
                        if (millenium > 0) {
                            if (millenium == 1) {
                                resultString = resultString + millenium + " millenium, ";
                            } else {
                                resultString = resultString + millenium + " millenia, ";
                            }
                        }
                        if (century > 0) {
                            if (century == 1) {
                                resultString = resultString + century + " century, ";
                            } else {
                                resultString = resultString + century + " centuries, ";
                            }
                        }
                        if (year > 0) {
                            if (year == 1) {
                                resultString = resultString + year + " year, ";
                            } else {
                                resultString = resultString + year + " years, ";
                            }
                        }
                        if (day > 0) {
                            if (day == 1) {
                                resultString = resultString + day + " day, ";
                            } else {
                                resultString = resultString + day + " days, ";
                            }
                        }
                        if (hour > 0) {
                            if (hour == 1) {
                                resultString = resultString + hour + " hr, ";
                            } else {
                                resultString = resultString + hour + " hrs, ";
                            }
                        }
                        if (minute > 0) {
                            if (minute == 1) {
                                resultString = resultString + minute + " min, ";
                            } else {
                                resultString = resultString + minute + " mins, ";
                            }
                        }
                        if (second > 0) {
                            if (second == 1) {
                                resultString = resultString + second + " sec, ";
                            } else {
                                resultString = resultString + second + " secs, ";
                            }
                        }
                        resultString = resultString.slice(0, resultString.length - 2);
                    }
                }
                var obj = document.getElementById("time" + x);
                obj.innerHTML = resultString;

            };
            return false;
        }

    }

    $('#calcNow').click(function () {
        calc();
    });

    $('form[name="fileInfo"]').submit(function (event) {
        event.preventDefault();
        calc();
    });

    $('input[name=fileSizeType]').change(function () {
        calc();
    });

};

DB.refreshLazyLoading = function () {
    if (window['lazyLoadInstance'] !== undefined) {
        lazyLoadInstance.update();
    }
};

DB.waypointCallback = function () {
    DB.utils.animationedSections();
    $('.js-equal-height').matchHeight();

    DB.refreshLazyLoading();
    DB.gifOnHover();
    DB.utils.hashAnchorClick();
    DB.utils.openPopupOnClick();
    DB.utils.magnific();
};

DB.calculate100vh = function () {
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

DB.utils.setCookie = function ({ name, val, days }) {
    var expires;

    if (days) {
        var data = new Date();
        data.setTime(data.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + data.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name + "=" + val + expires + "; path=/";
};

DB.utils.isCookieSet = function ({ name }) {
    if (document.cookie !== '') {
        var cookies = document.cookie.split("; ");

        for (var i = 0; i < cookies.length; i++) {
            var cookieName = cookies[i].split("=")[0];
            var cookieVal = cookies[i].split("=")[1];

            if (cookieName === name) {
                return decodeURI(cookieVal);
            }
        }
    }
}

// Cookie
DB.cookieNotification = {
    cookieName: 'cookieNotification',
    button: document.querySelector('.js-cookie-btn'),
    layer: document.querySelector('.js-cookie'),
    show: function () {

        if (!(DB.utils.isCookieSet({ name: this.cookieName }))) {
            this.layer.classList.add('cookie--show');
        }
    },
    save: function () {
        DB.utils.setCookie({
            name: this.cookieName,
            val: true,
            days: 30
        });
        this.layer.classList.remove('cookie--show');
        return false;
    },
    init: function () {
        if (this.layer) {
            this.show();
        }
    }
};

function hashInUrlScrollTo() {
    if (window.location.hash && window.location.hash !== '#contact') {
        DB.utils.scrollToID(window.location.hash, 'html,body', 80);
    }
}

function runScriptsBeforeFadeInTransition() {
    DB.underlineHoverEffect();
}

function runUniversalScripts(options = {}) {
    DB.sliders.init();

    DB.utils.animationedSections();

    $('.js-equal-height').matchHeight();
    $('.js-equal-height-2').matchHeight();
    $('.js-equal-height-3').matchHeight();

    DB.utils.infiniteScroll(DB.waypointCallback);
    DB.gifOnHover();
    DB.selectBox.init();

    if (!options.firstTime) {
        DB.refreshLazyLoading();
        DB.underlineHoverEffect();
        DB.buttonHoverEffect();
    }

    DB.utils.hashAnchorClick();
    DB.utils.openPopupOnClick();
    DB.utils.magnific();
}

function runWebsiteScripts(options) {
    runUniversalScripts(options);

    DB.scrollToActiveElement();

    DB.calculate100vh();
    DB.comparisonBlock.init();

    DB.utils.formBuilder.init();
    DB.utils.initValidation();
    DB.sidebar();

    DB.audioPlayer.init();
    DB.accordion.init();
    DB.calculator();

    DB.skrollr();
    DB.contact.initLinksToOpenContact();

    setTimeout(function () {
        hashInUrlScrollTo();
    }, 600);
}

function runWebsiteScriptsOnce() {
    DB.navigationVisibility();
    DB.mobileMenu.init();
    DB.searchForm();
    DB.megamenu.init();
    DB.contact.init();
    DB.cookieNotification.init();

    DB.selectBox.init();
}

function trackPageGTM() {
    if (window['dataLayer'] !== undefined) {
        let pagePath = window.location.pathname;

        window.dataLayer.push({
            'event': 'content-view',
            'content-name': pagePath
        });
    }
}

/*
 * -----------------------------------------------------------
 * // Dynamic loading via Barba.js and its settings start here
 *
*/


const FadeTransition = Barba.BaseTransition.extend({
    start: function () {
        Promise
            .all([this.fadeOut(), this.newContainerLoading])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function () {
        var deferred = new jQuery.Deferred();
        let menuWasOpened = false;
        let fadeOutTimeout = 200;
        const burger = document.querySelector('.burger');
        const currentStatus = Barba.HistoryManager.currentStatus();
        const prevStatus = Barba.HistoryManager.prevStatus();

        if (burger) {
            if (burger.classList.contains('burger--open')) {
                burger.click();
                menuWasOpened = true;
            }
        }

        Waypoint.destroyAll();

        if (DB.skrollrInstance) {
            DB.skrollrInstance.destroy();
        }

        setTimeout(function () {
            $("html, body").animate({ scrollTop: 0 }, "fast");
            deferred.resolve();
        }, fadeOutTimeout);

        let transition = {};

        if (!($('.website-holder--open').length)) {
            $('.curtain').addClass('curtain--active');
            transition = {
                opacity: 0
            }
        };

        //Important! If address url for page "who-we-are" will be changed the condition below must be changed! 
        if (prevStatus && prevStatus.namespace === 'team' && currentStatus.url !== undefined && currentStatus.url.indexOf("who-we-are") !== -1) {
            $(this.oldContainer).find(".l-main").addClass("fadeOutLeft");
        }

        return deferred.promise().then(() => {
            return $(this.oldContainer).animate(transition, 200).promise();
        });
    },

    fadeIn: function () {
        function destroyOwlCarousels() {
            if (!($('.owl-loaded').length)) {
                return;
            }

            $('.owl-loaded').trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
            $('.owl-loaded').find('.owl-stage-outer').children().unwrap();
        }

        var _this = this;
        var $el = $(this.newContainer);
        let curtainHideTimeout = 0;
        let fadeInDelay = 0;
        let transition = {
            opacity: 1
        }

        if ($('.website-holder--open').length && $el.find('.l-sidebar').length === 0) {
            $('.curtain').addClass('curtain--active');
            fadeInDelay = 0;

            curtainHideTimeout = 500;
        }

        destroyOwlCarousels();

        setTimeout(function () {
            $(this.oldContainer).hide();
        }, curtainHideTimeout ? curtainHideTimeout - 400 : 0);

        $el.css({
            visibility: 'visible',
            opacity: 0
        });

        setTimeout(function () {
            $('.curtain').removeClass('curtain--active');
        }, curtainHideTimeout ? curtainHideTimeout + 300 : curtainHideTimeout);

        function recalculateEqualRowsInFooter() {
            $('.l-footer .js-equal-height').matchHeight();
        }

        runScriptsBeforeFadeInTransition();
        setTimeout(function () {
            const currentStatus = Barba.HistoryManager.currentStatus();
            const prevStatus = Barba.HistoryManager.prevStatus();

            if (currentStatus && currentStatus.namespace === 'team' && prevStatus && prevStatus.namespace === 'team') {
                $el.find(".l-main").addClass("animation-fadeInRight fadeInRight animated");
            }

            $el.animate(transition, 0, function () {
                let sidebar = $el.find('.l-sidebar');
                let websiteHolder = $('.website-holder');

                if (sidebar.length) {
                    if (DB.utils.isCookieSet({ name: 'sidebarOpen' }) === undefined) {
                        setTimeout(function () {
                            websiteHolder.addClass('website-holder--open');
                        }, 400);

                        setTimeout(function () {
                            recalculateEqualRowsInFooter();
                        }, 800);
                    }

                    hashInUrlScrollTo();
                    _this.done();

                } else if (!sidebar.length && websiteHolder.hasClass('website-holder--open')) {
                    websiteHolder.removeClass('website-holder--open');
                    recalculateEqualRowsInFooter();

                    setTimeout(function () {
                        hashInUrlScrollTo();
                        _this.done();
                    }, 600);
                } else {
                    hashInUrlScrollTo();
                    _this.done();
                }

            });
        }, fadeInDelay);
    }
});

Barba.Pjax.getTransition = function () {
    const prev = Barba.HistoryManager.prevStatus();

    return FadeTransition;
};

Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;

Barba.Pjax.preventCheck = function (evt, element) {

    if ($(element).attr('href') && $(element).attr('href').indexOf('#') > -1 || $(element).hasClass('no-barba')) {
        return false;
    }
    else {
        return Barba.Pjax.originalPreventCheck(evt, element);
    }
};

Barba.Dispatcher.on('transitionCompleted', function (currentStatus, oldStatus) {
    let firstTime = oldStatus ? false : true;
    runWebsiteScripts({ firstTime });

    if (!($('#critical-css').length)) {
        window.location.reload();
    }
});

Barba.Dispatcher.on('newPageReady', function (current, prev, container) {
    history.scrollRestoration = 'manual';
    trackPageGTM();

    if ($('body').hasClass('stop-scrolling')) {
        DB.utils.enableBodyScrolling();
    }
});
/*
* -----------------------------------------------------------
*/

let barbaContainer = $('.barba-container').length;

if (barbaContainer) {
    Barba.Pjax.start();
    Barba.Pjax.getTransition();
    Barba.Pjax.cacheEnabled = false;
    Barba.Prefetch.init();

} else {
    runWebsiteScripts();
}

runWebsiteScriptsOnce();

window.addEventListener('resize', function () {
    setTimeout(function () {
        Waypoint.refreshAll();
    }, 80);

}, false);

window.addEventListener('scroll', function () {
    DB.navigationVisibility();
}, false);